import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { NeoImporterFilter, NeoImporterTable } from "../components";
import * as neoImporter from "../redux";
import { getNeoImportersList, getNeoImportersLoading, getNeoImportersLoaded, getNeoImportersPagination } from "../redux/selectors";

export const NeoImporterList = (props) => {
    const {
        neo_importers,
        pagination,
        changePage,
        loading,
        extraProps,
        getImportList,
        changeFilters
    } = props;

    // State for field_info if needed, formerly in this.state.field_info
    // Note: It was initialized in constructor but never seemingly used or updated in the original code?
    // We'll keep it for compatibility if it was intended for future use.
    const [fieldInfo] = useState({});

    useEffect(() => {
        getImportList();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onFilter = filters => {
        changeFilters(filters);
    };

    const base_op = {
        className: "costpackage_list",
        breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Importers Log" }],
        extraProps,
        loading
    };

    const costpackageTable_op = {
        list: neo_importers,
        pagination: {
            ...pagination,
            changePage
        }
    };

    return (
        <Base {...base_op}>
            <NeoImporterFilter onSubmit={onFilter} field_info={fieldInfo} />
            <NeoImporterTable {...costpackageTable_op} />
        </Base>
    );
};

// Using existing selectors we created earlier would be better practice here!

const mapStateToProps = store => ({
    neo_importers: getNeoImportersList(store),
    loading: getNeoImportersLoading(store),
    loaded: getNeoImportersLoaded(store),
    pagination: getNeoImportersPagination(store)
});

const mapDispatchToProps = dispatch => ({
    getImportList: () => dispatch(neoImporter.actions.getImporters()),
    changePage: page => dispatch(neoImporter.actions.changePage(page)),
    changeFilters: filters => dispatch(neoImporter.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(NeoImporterList);
